import { get } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

const apiName = "vc-proposal-generator";
const path = "/proposal-generator/";

async function getAuthHeaders() {
  try {
    const session = await fetchAuthSession();
    if (session.tokens?.idToken) {
      return {
        Authorization: `Bearer ${session.tokens.idToken.toString()}`
      };
    }
    return {};
  } catch (error) {
    console.log('Error getting auth headers:', error);
    return {};
  }
}

export async function getVersions() {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "versions",
      }
    }
  }).response;
  
  const result = await response.body.json();
  return result;
}
